import { inject } from '@angular/core';
import { type ResolveFn } from '@angular/router';
import { ConsultationFacade } from '../services/consultation/consultation-facade';
import { ConsultationState } from '../services/state/consultation-state';

export const consultationResolver: ResolveFn<boolean> = async (route) => {
  const consultationFacade = inject(ConsultationFacade);
  const consultationState = inject(ConsultationState);

  const guid = route.paramMap.get('id');

  if (!guid) {
    return false;
  }

  // If the consultationId in state already matches this guid, it was freshly started
  // by newConsultationGuard — skip loading from the API.
  if (consultationState.consultationId() === guid) {
    return false;
  }

  // Load existing consultation
  await consultationFacade.loadOldConsultation(guid);

  return true;
};
